export const NHS_COOKIE_NAME: string = "nhsuk-cookie-consent";
